import React, { memo } from "react";
import { Icon, IconProps } from "@chakra-ui/icon";

const FontHighlightColorIcon = (props: IconProps) => (
  <Icon width="20px" height="20px" viewBox="0 0 20 20" {...props}>
    <path d="M16.5286 3.63064L15.2962 2.30679C14.5018 1.4534 13.2083 1.4534 12.4138 2.30679L9.68418 5.23896L0.833252 14.7466V19.1667H4.94807L13.8499 9.60438L16.5286 6.72692C17.3333 5.87353 17.3333 4.48403 16.5286 3.63064ZM4.1027 16.9786H2.87029V15.6547L11.6907 6.17988L12.9231 7.50373L4.1027 16.9786ZM8.9814 19.1667L13.0555 14.7904H19.1666V19.1667H8.9814Z" />
  </Icon>
);

export default memo(FontHighlightColorIcon);
